import type {
  City,
  County,
  CountyFips,
  USAState,
  USAStateAcronym,
  ZipCode,
} from '@hc-frontend/core-types';
import { USAStatesList } from '@hc-frontend/core-types';
import { filter, isEmpty, isNil } from 'ramda';

import type { Location } from '../../domain';
import type { userAttributesMapper } from './user-attributes-mapper';

export function locationMapper(
  userAttributesMap: ReturnType<typeof userAttributesMapper>,
): Location | undefined {
  const props = {
    zipCode: userAttributesMap.zip,
    stateAcronym: userAttributesMap.state,
    county: userAttributesMap.county,
    city: userAttributesMap.city,
    countyFips: userAttributesMap.countyFips,
  };

  if (!isEmpty(filter(isNil, props))) {
    return undefined;
  }

  const stateName = USAStatesList.find(
    (state) => state.code === userAttributesMap.state,
  );

  const location: Location = {
    zipCode: userAttributesMap.zip as ZipCode,
    stateAcronym: userAttributesMap.state as USAStateAcronym,
    county: userAttributesMap.county as County,
    city: userAttributesMap.city as City,
    countyFips: userAttributesMap.countyFips as CountyFips,
    state: stateName?.name as unknown as USAState,
  };

  return location;
}
